import React, {Fragment, Component} from 'react';
import {Link} from 'react-router-dom';
import WOW from 'wowjs';
import Header from './../Layout/Header';
import FooterPremium from './../Layout/FooterPremium';
import PageTitle from './../Layout/PageTitle';

// Images
import banner1 from './../../images/banner/towera.png';
import banner2 from './../../images/banner/towerb.png';
import banner from './../../images/banner/views1.png';
import ban2 from './../../images/banner/views2.png';
import main1 from './../../images/main-slider/9.jpeg';
import main2 from './../../images/main-slider/1.jpeg';
import main3 from './../../images/main-slider/12.jpeg';
import main4 from './../../images/about/towerabnew.png';
import goldcrestExecutive from './../../images/about/goldcrestExecutive.png';

const Footer2 = FooterPremium;

const projects = [
	{
		id: 1,
		name: "Goldcrest Tower A",
		image: banner1,
		status: "Completed",
		statusColor: "#28a745",
		link: "/goldcrest-dream-tower-a",
		features: [
			"Fully completed, ready to occupy",
			"Elegant design and quality finishes",
			"State-of-the-art amenities",
			"Comfortable, convenient, and modern living"
		]
	},
	{
		id: 2,
		name: "Goldcrest Tower B",
		image: banner2,
		status: "Completed",
		statusColor: "#28a745",
		link: "/goldcrest-dream-tower-b",
		features: [
			"Completed residential tower with premium living features",
			"Various apartment layouts: studio, 1-bedroom, 2-bedroom",
			"Strategically located for convenience"
		]
	},
	{
		id: 3,
		name: "Goldcrest Views",
		image: banner,
		status: "Completed",
		statusColor: "#28a745",
		link: "/contact-us",
		features: [
			"Panoramic views and luxurious living",
			"Various apartment layouts: studio, 1-bedroom, 2-bedroom",
			"High-quality finishes and elegant design",
			"State-of-the-art amenities"
		]
	},
	{
		id: 4,
		name: "Goldcrest View 2",
		image: ban2,
		status: "Completed",
		statusColor: "#28a745",
		link: "/contact-us",
		features: [
			"Modern residential project redefining urban living",
			"Outstanding architectural design",
			"Various apartment layouts: studio, 1-bedroom, 2-bedroom",
			"24-floor Residential Tower in Dubai - Delivered in 2022"
		]
	},
	{
		id: 5,
		name: "Goldcrest Executive",
		image: goldcrestExecutive,
		status: "Completed",
		statusColor: "#28a745",
		link: "/contact-us",
		features: [
			"Premium commercial spaces in Jumeira Lake Towers, Dubai",
			"Modern offices and retail designed for growth and visibility",
			"Strategic location with strong connectivity",
			"Delivered with high-quality finishes and amenities"
		]
	}
];

class Projects extends Component{
	componentDidMount(){
		new WOW.WOW().init();
	}
	
	render(){
		return(
			<Fragment>
				<style>{`
					.projects-hero-section {
						padding: 100px 0 80px;
						background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
					}
					.projects-hero-title {
						font-size: 35px;
						font-weight: 800;
						color: #1a1a1a;
						line-height: 1.2;
						margin-bottom: 25px;
						letter-spacing: -1px;
					}
					.projects-hero-title span {
						color: #b8975f;
					}
					.projects-hero-text {
						font-size: 18px;
						line-height: 1.8;
						color: #666;
						margin-bottom: 35px;
					}
					.projects-hero-text.projects-hero-text-compact {
						margin-top: -12px;
						margin-bottom: 22px;
						font-size: 16px;
						opacity: 0.95;
					}
					.projects-hero-image-row {
						width: 100%;
						justify-content: center;
						align-items: center;
						min-height: 360px; /* balances left content height */
					}
					@media (max-width: 991.98px) {
						.projects-hero-image-row {
							min-height: auto;
						}
					}
					.projects-feature-card {
						display: flex;
						align-items: center;
						padding: 15px;
						background: #fff;
						border-radius: 10px;
						box-shadow: 0 2px 10px rgba(0,0,0,0.05);
						margin-bottom: 15px;
					}
					.projects-feature-icon {
						width: 50px;
						height: 50px;
						border-radius: 50%;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-right: 15px;
						flex-shrink: 0;
					}
					.projects-feature-icon.green {
						background: linear-gradient(135deg, #000000 0%, #a5895a 100%);
					}
					.projects-feature-icon.orange {
						background: linear-gradient(135deg, #000000 0%, #a5895a 100%);
					}
					.projects-feature-icon.blue {
						background: linear-gradient(135deg, #000000 0%, #a5895a 100%);
					}
					.projects-feature-icon i {
						color: #fff;
						font-size: 20px;
					}
					.projects-feature-text {
						font-size: 16px;
						color: #333;
						font-weight: 600;
					}
					.projects-hero-image-wrapper {
						position: relative;
						overflow: hidden;
						border-radius: 15px;
						box-shadow: 0 10px 30px rgba(0,0,0,0.15);
						transition: transform 0.3s ease;
					}
					.projects-hero-image-wrapper:hover {
						transform: translateY(-5px);
					}
					.projects-hero-image {
						width: 100%;
						height: 220px;
						object-fit: cover;
						display: block;
					}
					.projects-section-title {
						font-size: 42px;
						font-weight: 800;
						color: #1a1a1a;
						margin-bottom: 15px;
						letter-spacing: -1px;
					}
					.projects-section-title span {
						color: #b8975f;
					}
					.projects-section-subtitle {
						font-size: 18px;
						color: #666;
						max-width: 700px;
						margin: 0 auto;
					}
					.projects-grid-section {
						padding: 80px 0;
						background: #fff;
					}
					/* Ensure equal-height cards (WOW wrapper was breaking stretch) */
					.projects-grid-section .wow {
						height: 100%;
						display: flex;
					}
					.projects-grid-section .wow > .projects-card {
						flex: 1;
					}
					.projects-card {
						background: #fff;
						border-radius: 10px;
						overflow: hidden;
						box-shadow: 0 5px 25px rgba(0,0,0,0.08);
						transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
						height: 100%;
						display: flex;
						flex-direction: column;
					}
					.projects-card:hover {
						transform: translateY(-10px);
						box-shadow: 0 15px 40px rgba(0,0,0,0.15);
					}
					.projects-card-image-container {
						position: relative;
						overflow: hidden;
						height: 320px;
						background: #f0f0f0;
					}
					.projects-card-image {
						width: 100%;
						height: 100%;
						object-fit: cover;
						transition: transform 0.5s ease;
					}
					.projects-card:hover .projects-card-image {
						transform: scale(1.1);
					}
					.projects-image-overlay {
						position: absolute;
						bottom: 0;
						left: 0;
						right: 0;
						height: 100px;
						background: linear-gradient(to top, rgba(0,0,0,0.6), transparent);
					}
					.projects-card-content {
						padding: 15px;
						flex: 1;
						display: flex;
						flex-direction: column;
					}
					.projects-card-title {
						font-size: 28px;
						font-weight: 700;
						color: #1a1a1a;
						margin-bottom: 7px;
						line-height: 1.3;
					}
					.projects-card-features {
						list-style: none;
						padding: 0;
						margin-bottom: 25px;
						flex: 1;
					}
					.projects-card-features li {
						margin-bottom: 12px;
						font-size: 15px;
						color: #555;
						display: flex;
						align-items: flex-start;
						line-height: 1.6;
					}
					.projects-card-features li i {
						color: #b8975f;
						margin-right: 12px;
						margin-top: 3px;
						font-size: 16px;
						flex-shrink: 0;
					}
					.projects-card-button {
						display: inline-block;
						width: 100%;
						text-align: center;
						    background: linear-gradient(135deg, #656565 0%, #000000 100%);
						color: #fff;
						margin-top: auto;
						padding: 14px 30px;
						border-radius: 10px;
						font-weight: 700;
						font-size: 16px;
						text-decoration: none;
						transition: all 0.3s ease;
						    box-shadow: 0 4px 15px rgb(86 86 86);
						border: none;
						text-transform: uppercase;
						letter-spacing: 0.5px;
					}
					.projects-card-button:hover {
						transform: translateY(-2px);
						box-shadow: 0 6px 20px rgba(227, 144, 1, 0.4);
						color: #fff;
						text-decoration: none;
					}
					.projects-cta-section {
						padding: 100px 0;
						background: linear-gradient(135deg, rgba(227, 144, 1, 0.95) 0%, rgba(184, 148, 31, 0.95) 100%);
						position: relative;
						overflow: hidden;
					}
					.projects-cta-pattern {
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
						opacity: 0.1;
					}
					.projects-cta-content {
						position: relative;
						z-index: 1;
					}
					.projects-cta-title {
						font-size: 42px;
						font-weight: 800;
						color: #fff;
						margin-bottom: 20px;
						letter-spacing: -1px;
					}
					.projects-cta-text {
						font-size: 20px;
						color: rgba(255,255,255,0.95);
						margin-bottom: 40px;
						max-width: 600px;
						margin-left: auto;
						margin-right: auto;
					}
					.projects-cta-button {
						display: inline-block;
						background: #fff;
						color: #b8975f;
						padding: 18px 50px;
						border-radius: 50px;
						font-weight: 800;
						font-size: 18px;
						text-decoration: none;
						transition: all 0.3s ease;
						box-shadow: 0 8px 30px rgba(0,0,0,0.3);
						text-transform: uppercase;
						letter-spacing: 1px;
					}
					.projects-cta-button:hover {
						transform: translateY(-3px) scale(1.05);
						box-shadow: 0 12px 40px rgba(0,0,0,0.4);
						color: #b8975f;
						text-decoration: none;
					}
				`}</style>
				<Header />
				<div className="page-content bg-white">
					<PageTitle motherMenu="Completed Projects" activeMenu="Completed Projects" />
					
					{/* Hero Section */}
					<section className="content-inner projects-hero-section">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-lg-6 mb-5 mb-lg-0">
									<div className="wow fadeInLeft" data-wow-duration="1s">
										<h2 className="projects-hero-title">
											OWN A PLACE WHERE <span>LIFE'S A DREAM</span>, AND YOU'RE LIVING IT
										</h2>
										<p className="projects-hero-text">
											Discover homes that blend luxury, comfort, and modern living—your dream sanctuary at Star Giga.
										</p>
										<p className="projects-hero-text projects-hero-text-compact">
											From delivered landmarks to signature developments, every Star Giga project is shaped by thoughtful design, quality construction, and amenities that elevate everyday living—created to offer lasting value for homeowners and investors alike.
										</p>
									</div>
								</div>
								<div className="col-lg-6 d-flex align-items-center justify-content-center">
									<div className="row wow fadeInRight projects-hero-image-row" data-wow-duration="1s">
										<div className="col-6 mb-3">
											<div className="projects-hero-image-wrapper">
												<img src={main1} alt="Interior" className="projects-hero-image" />
											</div>
										</div>
										<div className="col-6 mb-3">
											<div className="projects-hero-image-wrapper">
												<img src={main2} alt="Lobby" className="projects-hero-image" />
											</div>
										</div>
										<div className="col-6">
											<div className="projects-hero-image-wrapper">
												<img src={main3} alt="Construction" className="projects-hero-image" />
											</div>
										</div>
										<div className="col-6">
											<div className="projects-hero-image-wrapper">
												<img src={main4} alt="Interior Design" className="projects-hero-image" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* Projects Grid Section */}
					<section className="content-inner projects-grid-section">
						<div className="container">
							<div className="row mb-5">
								<div className="col-12 text-center">
									<h2 className="projects-section-title">
										Our <span>Completed Projects</span>
									</h2>
									<p className="projects-section-subtitle">
										Discover our delivered residential and commercial developments—ready to occupy and designed for modern living.
									</p>
								</div>
							</div>
							
							<div className="row">
								{projects.map((project, index) => (
									<div key={project.id} className="col-lg-4 col-md-6 mb-4">
										<div className="wow fadeInUp" data-wow-delay={`${index * 0.1}s`}>
											<div className="projects-card">
												{/* Image Container */}
												<div className="projects-card-image-container">
													<img 
														src={project.image} 
														alt={project.name}
														className="projects-card-image"
													/>
													{/* Overlay Gradient */}
													<div className="projects-image-overlay"></div>
												</div>
												
												{/* Content */}
												<div className="projects-card-content">
													<h3 className="projects-card-title">
														{project.name}
													</h3>
													
													<ul className="projects-card-features">
														{project.features.map((feature, idx) => (
															<li key={idx}>
																<i className="fa fa-check-circle"></i>
																<span>{feature}</span>
															</li>
														))}
													</ul>
													
													<Link 
														to={project.link}
														className="projects-card-button"
													>
														View Details <i className="fa fa-arrow-right ml-2"></i>
													</Link>
												</div>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</section>

					{/* Call-to-Action Section */}
					{/* <section className="content-inner projects-cta-section">
						<div className="projects-cta-pattern"></div>
						<div className="container projects-cta-content">
							<div className="row">
								<div className="col-12 text-center">
									<h2 className="projects-cta-title">
										Ready to Find Your Dream Property?
									</h2>
									<p className="projects-cta-text">
										Speak with our expert team and discover the perfect property that matches your lifestyle and investment goals.
									</p>
									<Link 
										to="/contact-us"
										className="projects-cta-button"
									>
										Request Consultation <i className="fa fa-arrow-right ml-2"></i>
									</Link>
								</div>
							</div>
						</div>
					</section> */}
				</div>
				<Footer2 />
			</Fragment>
		)
	}
}

export default Projects;
